<template>
  <div
    class="hs-button"
    :class="className"
    :size="size"
    :style="{width: width, height: height, fontSize: fontSize}"
    @click.stop="!disable && $emit('click')"
  >
    <slot></slot>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '34px'
    },
    fontSize: {
      type: String,
      default: '1rem'
    },
    disable: {
      type: Boolean,
      default: false
    },
    fontType: {
      type: String,
      default: ''
    },
    size: { // small
      type: String,
      default: ''
    }
  },
  computed: {
    className() {
      let className = []
      if (this.disable) {
        className.push('disable-status')
      }
      if (this.fontType === 'S') {
        className.push('font-s')
      }
      return className
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-button
  @extend .flex-center
  background-color $color_theme
  color $color_white
  padding 0 15px
  border-radius 3px
.hs-button[type="common"]
  @extend .flex-center
  background-color $color_white
  color $color_theme
  border 1px solid $color_theme
  padding 0 15px
  border-radius 3px
.hs-button[type="gradient"]
  background $color_red_gradient_1
  padding 0 5px
.hs-button[type="disabled"]
  @extend .disabled
  background-color $color_gray_text
  padding 0 5px
.hs-button[type="disabled1"]
  @extend .disabled
  background-color $color_white
  border 1px solid $color_border_gray
  padding 0 5px
  color $color_gray_text
.hs-button[type="disabled2"]
  min-width 58px
  background-color $color_font_gray_3
.hs-button[type="gray"]
  background-color $color_white
  border 1px solid $color_border_gray_1
  padding 0 5px
  color $color_font_black
.hs-button[type="gradient1"]
  min-width 58px
  background $color_background_liner_theme_4
.hs-button[type="white-border"]
  background $color_white
  border 1px solid $color_border_gray
  border-radius 50vmin
.hs-button[type="yellow"]
  min-width 58px
  background $color_background_theme_2


.hs-button[type="theme"]
  @extend .hs-font-subtitle-big
  min-width 58px
  background $color_theme_300
  color $color_black_0
  border-radius 8px
  padding 0 16px
  &[size='small']
    @extend .hs-font-overline-1
    border-radius 4px
    padding 0 12px
    min-width 56px
  &.font-s
    @extend .hs-font-overline-1
  &:active
    background $color_theme_200
  &.disable-status
    background $color_theme_300
    color rgba(255, 255, 255, 0.5)
.hs-button[type="default"]
  @extend .hs-font-subtitle-big
  min-width 58px
  background $color_black_40
  color $color_black_500
  border-radius 8px
  padding 0 16px
  &.font-s
    @extend .hs-font-overline-1
  &:active
    background $color_black_50
  &.disable-status
    background $color_black_40
    color $color_black_50
.hs-button[type="light-theme"]
  @extend .hs-font-overline-1
  min-width 56px
  background rgba(240, 24, 42, 0.08)
  color $color_theme_300
  border-radius 4px
  padding 0 8px
  border 1px solid $color_theme_75
  &.font-s
    @extend .hs-font-overline-1
  &:active
    color $color_theme_200
  &.disable-status
    color $color_theme_75
</style>
